<template>
	<inertia-head title="TRC AI Circle" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h3 class="fw-bold text-white mb-2">
						{{
							`Welcome to the ${$page.props.app.name} - AI Circle`
						}}
					</h3>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						TRC AI Circle Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div v-if="is_expired=='Yes'">
			<div class="block mb-0 border-bottom" >
				<div class="block-content block-content-full text-center">
					<p class="h4">Your subscription is already expired, please renew your TRC AI Circle. Click the button below.</p>
					<div class="mt-4">
						<inertia-link href="/member/trc-ai-circle/renew" class="fs-xs btn btn-info"><i class="fa fa-arrow-circle-up me-2"></i>TRC AI Circle Renewal</inertia-link>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="row">
			<div v-if="$page.props.welcome_vimeo_id!=null && $page.props.welcome_vimeo_id!=0" class="col-12 mb-7">
				<div class="aic-welcome">
					<div class="aic-welcome__video">
						<iframe class="shadow-sm" :src="'https://player.vimeo.com/video/'+$page.props.welcome_vimeo_id" allowfullscreen></iframe>
					</div>
					<div class="aic-welcome__content">
						<p class="aic-welcome__eyebrow">Start Here</p>
						<h1 class="aic-welcome__title">Welcome to TRC AI Circle</h1>
						<p>
							Thank you for joining the TRC AI Circle, we're so glad you're here. This is your space inside the Truly Rich Club family for learning how to actually use AI to grow your business, manage your money, and save yourself hours of work each week.
						</p>
						<p>
							No tech background needed, no jargon, no hype, just practical, Filipino-friendly guides written for real people with real lives. We've got exciting things lined up: hands-on tutorials, tool reviews, AI tips for investors and entrepreneurs, and updates on what's worth paying attention to (and what's not).
						</p>
						<p>
							Watch this space! The journey is just beginning.
						</p>
						<div class="aic-quick-links">
							<h2 class="aic-quick-links__title">Quick Links</h2>
							<div class="aic-quick-links__actions">
								<inertia-link :href="route('member.trc-ai-circle.latest-updates')" class="btn btn-alt-primary aic-quick-links__button">
									<i class="fa fa-newspaper me-2"></i>Latest Updates
								</inertia-link>
								<a
									:href="$page.props.whatsapp_group_url || 'javascript:void(0)'"
									class="btn btn-alt-secondary aic-quick-links__button"
									:class="{ disabled: !$page.props.whatsapp_group_url }"
									:aria-disabled="!$page.props.whatsapp_group_url"
									target="_blank"
								>
									<i class="fab fa-whatsapp me-2"></i>Join Exclusive WhatsApp Group
								</a>
								<a
									:href="$page.props.weekly_zoom_url || 'javascript:void(0)'"
									class="btn btn-alt-secondary aic-quick-links__button"
									:class="{ disabled: !$page.props.weekly_zoom_url }"
									:aria-disabled="!$page.props.weekly_zoom_url"
									target="_blank"
								>
									<i class="fa fa-video me-2"></i>Join Weekly Zoom Session
								</a>
							</div>
						</div>
					</div>
				</div>
	        </div>

	        <div v-if="announcements.length>0" class="col-12 mb-6">
				<h4 class="mb-0 border-bottom border-3 border-danger">Announcements</h4>
				<div v-for="(announcement,a_index) in announcements" class="block mb-0 border-bottom" :class="{'border-top':a_index>0}">
					<div class="block-content block-content-full">
						<div class="fw-semibold h2 mb-0">{{announcement.title}}</div>
						<div class="fs-xs text-muted fst-italic">{{announcement.posted_date}}</div>
		                <div class="fs-sm mt-4" style="white-space: pre; white-space:break-spaces;" v-html="announcement.description">
			                
			            </div>
		                <div v-if="announcement.announcement_img_url!==null" class="mt-5 text-center overflow-hidden">
		                	<img :src="announcement.announcement_img_url" class="img img-fluid" />
		                </div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props: {
		user 			: Object,
		is_expired 		: String,
		announcements 	: Object,
		flash 			: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

	},
}
</script>

<style scoped>
.aic-welcome {
	display: grid;
	grid-template-columns: minmax(260px, 420px) minmax(0, 1fr);
	gap: 2.5rem;
	align-items: center;
	max-width: 1180px;
	margin: 0 auto;
	padding: 2rem;
	background: #fff;
	border: 1px solid rgba(33, 37, 41, .08);
	border-radius: .5rem;
}

.aic-welcome__video {
	width: 100%;
	max-width: 360px;
	aspect-ratio: 9 / 16;
	justify-self: center;
	overflow: hidden;
	border-radius: .5rem;
	background: #111827;
}

.aic-welcome__video iframe {
	width: 100%;
	height: 100%;
	border: 0;
}

.aic-welcome__eyebrow {
	margin-bottom: .5rem;
	color: #f0ad00;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: .04em;
}

.aic-welcome__title {
	margin-bottom: 1.25rem;
	color: #343b45;
	font-size: clamp(2rem, 4vw, 3.5rem);
	font-weight: 700;
	line-height: 1.1;
}

.aic-welcome__content {
	color: #3e444a;
	font-size: 1.075rem;
	line-height: 1.65;
}

.aic-quick-links {
	margin-top: 1.75rem;
	padding: 1.25rem;
	background: #f8f9fb;
	border: 1px solid rgba(33, 37, 41, .08);
	border-radius: .5rem;
}

.aic-quick-links__title {
	margin-bottom: 1rem;
	color: #343b45;
	font-size: 1rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: .04em;
}

.aic-quick-links__actions {
	display: grid;
	gap: .75rem;
}

.aic-quick-links__button {
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
	white-space: normal;
	text-align: center;
}

@media (max-width: 991.98px) {
	.aic-welcome {
		grid-template-columns: 1fr;
		padding: 1.5rem;
	}
}
</style>
